/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginUserDto
 */
export interface LoginUserDto {
    /**
     * 
     * @type {string}
     * @memberof LoginUserDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserDto
     */
    email: string;
}

export function LoginUserDtoFromJSON(json: any): LoginUserDto {
    return LoginUserDtoFromJSONTyped(json, false);
}

export function LoginUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
        'email': json['email'],
    };
}

export function LoginUserDtoToJSON(value?: LoginUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'email': value.email,
    };
}

